import React from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'sonner';
import { TooltipProvider } from '@radix-ui/react-tooltip';
import { queryClient } from './queryClient';
import { AuthProvider } from '@/services/auth/authContext';
import { ThemeProvider } from '@/themes';

interface ProvidersProps {
  children: React.ReactNode;
}

export const Providers: React.FC<ProvidersProps> = ({ children }) => {
  return (
    <ThemeProvider>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <TooltipProvider delayDuration={200}>
            {children}
            <Toaster
              theme="dark"
              position="top-right"
              toastOptions={{
                style: {
                  background: 'var(--bg-surface-elevated, #0f1420)',
                  border: '1px solid var(--border-default, #1e293b)',
                  color: 'var(--text-primary, #f8fafc)',
                  fontFamily: 'JetBrains Mono, monospace',
                  fontSize: '12px',
                },
              }}
            />
          </TooltipProvider>
        </AuthProvider>
      </QueryClientProvider>
    </ThemeProvider>
  );
};
